import Vue from 'vue';
/**
 * @param  {string} value
 * @return {string} 参数值
 */
export default Vue.filter('decode', function (value: string) {
    if (!value) {
        return '';
    }

    return decodeURIComponent(value);
});
